module.exports = __webpack_public_path__ + "img/orange-bullet.96d0880d.svg";